import { all, takeEvery, put, fork, call } from 'redux-saga/effects';
import actions from './actions';

export function* getUsers() {
  yield takeEvery(actions.FETCH_USERS_REQUESTED, function* (action) {
    try {
      // Yield same await in generator function
      const users = yield call(actions.getUsers, action.payload); // Yield call to Call async action
      yield put({ type: actions.FETCH_USERS_SUCCEEDED, users });
    } catch (error) {
      yield put({ type: actions.FETCH_USERS_FAILED, error: error.message });
    }
  });
}
// JSON.parse(localStorage.getItem('user'));

export function* deleteUser() {
  yield takeEvery(actions.DELETE_USER_REQUESTED, function* (action) {
      try {
          const user = yield call(actions.deleteUser, action.payload);
          yield put({ type: actions.DELETE_USER_SUCCEEDED, userDeleted: user });
      } catch (error) {
          yield put({ type: actions.DELETE_USER_FAILED, error: error.message });
      }
  });
}

export default function* rootSaga() {
  yield all([
    fork(getUsers),
    fork(deleteUser)
  ]);
}
